import React, { useState } from 'react';
import { FC } from 'react';
import { Icons } from '@components/Icon';
import { IconTemplate } from '@components/Icon/IconTemplate';
import useTranslations from '@hooks/useTranslation';
import { publicAssets } from '@utils/url.utils';
import { About, Description, Image, Label, Title, Wrapper } from './Hero.elements';

export interface HeroProps {
    titleKey: string;
    imageKey: string;
    descriptionKey?: string;
    listKeys?: string[];
}

const HeroTemplate: FC<HeroProps> = ({ titleKey, imageKey, descriptionKey, listKeys }) => {
    const { t } = useTranslations();

    return (
        <Wrapper>
            <Image src={publicAssets(`/${imageKey}`)} />
            <About>
                <Title dangerouslySetInnerHTML={{ __html: t(titleKey) }} />
                {descriptionKey && <Description dangerouslySetInnerHTML={{ __html: t(descriptionKey) }} />}
                {listKeys?.length > 0 &&
                    listKeys?.map((listKey, key) => (
                        <Label key={key}>
                            <IconTemplate name={Icons.CheckThin} />{' '}
                            <span dangerouslySetInnerHTML={{ __html: t(listKey) }} />
                        </Label>
                    ))}
            </About>
        </Wrapper>
    );
};

export default HeroTemplate;
